import { Config } from "../config/config.js";
import { Helper } from "../util/helper.js";
import React from "react";
export interface IconsComboBoxProps {
    value: string;
    onChange: (value: string) => void;
    dataSourceUrl?: string;
}

export class IconsComboBox extends React.Component<IconsComboBoxProps, any>{
    private ref: HTMLInputElement;
    private comboBox: kendo.ui.ComboBox;
    private dataSourceUrl: string;

    constructor(props: IconsComboBoxProps) {
        super(props);
        this.dataSourceUrl = Config.baseUrl;
        if (!Helper.isNullOrEmpty(props.dataSourceUrl)) {
            this.dataSourceUrl += props.dataSourceUrl;
        } else {
            this.dataSourceUrl += "Dashboard/GetIcons";
        }

    }

    componentDidMount() {
        this.comboBox = $(this.ref).kendoComboBox({            
            dataTextField: "Value",
            dataValueField: "Value",
            filter: "contains",
            suggest: true,
            value: this.props.value,
            template: (dataItem) => {
                const value = dataItem.Value;
                return `<div style="display: grid; grid-template-rows: 1fr; grid-template-columns: 200px auto">
                            <div style="grid-column: 1/2">${value}</div>
                            <div style="grid-column: 2/3">
                                <i class="fa-light fa-${value}"></i>
                            </div>
                        </div>`
            },
            clearButton: false,
            change: (ev) => {
                this.props.onChange(ev.sender.value())
            },
            dataSource: {
                type: "json",
                serverFiltering: true,
                transport: {
                    read: {
                        url: this.dataSourceUrl,
                        dataType: "json",
                        data: () => {
                            return {
                                search: $(this.ref).data("kendoComboBox").input.val()
                            }
                        }
                    }
                },
                schema: {
                    type: "json",
                    data: "Data",
                    model: {
                        fields: {
                            Value: { field: "Value", type: "string" },
                            Key: { field: "Key", type: "string" },
                        }
                    }
                }
            }
        }).data("kendoComboBox");
        this.comboBox.list.width(275);
    }
    componentDidUpdate(prevProps: IconsComboBoxProps) {
        if (prevProps.value != this.props.value) {
            this.comboBox.value(this.props.value);
        }
    }

    render() {
        return <input style={{ width: "100%" }} ref={(ref) => { this.ref = ref }} ></input>;
    }
}